import { ClockIcon } from "assets/icons";
import cn from "classnames";
import TimePicker from "react-time-picker";
import { FormField } from "ui/FormField";

import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import "./TimeInputClear.scss";

import { TimeInputProps } from "./TimeInput.types";

import styles from "./TimeInput.module.scss";

const TimeInput = ({
  label,
  errorMessage,
  errorWithoutMessage,
  action = null,
  onChange,
  value,
  clockIcon,
  ...props
}: TimeInputProps) => {
  return (
    <FormField label={label} errorMessage={errorMessage}>
      <div className={styles.timeInput_wrapper}>
        <TimePicker
          value={value}
          className={cn(styles.timeInput, {
            [styles.timeInput_error]: !!errorMessage || errorWithoutMessage
          })}
          onChange={onChange}
          clockIcon={clockIcon ?? <ClockIcon />}
          clearIcon={null}
          locale={"en"}
          format="HH:mm:ss"
          maxDetail="second"
          {...props}
        />
        {action}
      </div>
    </FormField>
  );
};

export default TimeInput;
